module.exports = __webpack_public_path__ + "static/media/pipe.4f34ffbc.png";